<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form (ngSubmit)="f.form.valid && onSubmit(f)" #f="ngForm" novalidate>
          <div class="row align-items-end">
            <div class="col-md-4 mb-3">
              <label for="inputTipoInforme" class="form-label" i18n>Tipo de informe</label>
              <select id="inputTipoInforme" class="form-select" name="tipoInforme" #tipoInforme="ngModel"
                [(ngModel)]="model.tipoInforme" required
                [ngClass]="{ 'is-invalid': (tipoInforme.invalid && f.submitted) || (tipoInforme.invalid && (tipoInforme.dirty || tipoInforme.touched))}">
                <option *ngFor="let tipo of tiposInforme" [value]="tipo">{{ tipo }}</option>
              </select>
            </div>
            <div class="col-md-2 mb-3">
              <label for="inputYear" class="form-label" i18n>Año</label>
              <select id="inputYear" class="form-select" name="year" #year="ngModel" [(ngModel)]="model.year" required
              [ngClass]="{ 'is-invalid': (year.invalid && f.submitted) || (year.invalid && (year.dirty || year.touched))}">
                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
              </select>
            </div>
            <div class="col-md-1 text-end mb-3">
              <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="f.invalid"><span
                  i18n>Descargar</span></button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
